export const APP_LANGUAGE_PSEUDO_LOCALIZATION_VALUE = 'x-pseudo';
export const APP_LANGUAGE_ENGLISH_VALUE = 'en';

export const APP_LANGUAGES = [
  {
    value: APP_LANGUAGE_PSEUDO_LOCALIZATION_VALUE,
    label: 'AdminHTML.LanguageSetting.Constant.appLanguages_PseudoLocalization'
  },
  {
    value: APP_LANGUAGE_ENGLISH_VALUE,
    label: 'AdminHTML.LanguageSetting.Constant.appLanguages_English'
  },
  { value: 'de', label: 'AdminHTML.LanguageSetting.Constant.appLanguages_German' }
];

export const DATE_FORMAT = {
  'x-pseudo': {
    number: 'YYYY-MM-DD',
    longDate: 'MMM DD, YYYY',
    shortDate: 'MMM DD',
    fullDate: 'MMM DD, YYYY, HH:mm A',
    fullDate2: 'DD MMM, YYYY, HH:mm A',
    fullDateNumber: 'YYYY-MM-DD hh:mm:ss A',
    fullDateStartWithTime: 'hh:mm A MMM DD, YYYY'
  },
  en: {
    number: 'YYYY-MM-DD',
    longDate: 'MMM DD, YYYY',
    longDate2: 'MMM Do, YYYY',
    shortDate: 'MMM DD',
    fullDate: 'MMM DD, YYYY, HH:mm A',
    fullDate2: 'DD MMM, YYYY, HH:mm A',
    fullDateNumber: 'YYYY-MM-DD hh:mm:ss A',
    fullDateStartWithTime: 'hh:mm A MMM DD, YYYY',
    time: 'HH:mm A',
    time12h: 'hh:mm A'
  },
  de: {
    number: 'YYYY-MM-DD',
    longDate: 'DD. MMM YYYY',
    longDate2: 'Do MMM YYYY',
    shortDate: 'DD. MMM',
    fullDate: 'DD. MMM YYYY, HH:mm A',
    fullDate2: 'MMM. DD YYYY, HH:mm A',
    fullDateNumber: 'YYYY-MM-DD hh:mm:ss A',
    fullDateStartWithTime: 'hh:mm A MMM DD, YYYY',
    time: 'HH:mm A',
    time12h: 'hh:mm A'
  }
};

// This is currently implemented for displaying date in new analytics
export const DATE_FORMAT_V2 = {
  'x-pseudo': {
    oneDay: 'MMM D, yyyy',
    fromDate: {
      multipleDays: 'MMM D',
      multipleMonths: 'MMM D',
      multipleYears: 'MMM D, yyyy'
    },
    toDate: {
      multipleDays: 'D, yyyy',
      multipleMonths: 'MMM D, yyyy',
      multipleYears: 'MMM D, yyyy'
    }
  },
  en: {
    oneDay: 'MMM D, yyyy',
    fromDate: {
      multipleDays: 'MMM D',
      multipleMonths: 'MMM D',
      multipleYears: 'MMM D, yyyy'
    },
    toDate: {
      multipleDays: 'D, yyyy',
      multipleMonths: 'MMM D, yyyy',
      multipleYears: 'MMM D, yyyy'
    }
  },
  de: {
    // Update later
    oneDay: 'MMM D, yyyy',
    fromDate: {
      multipleDays: 'MMM D',
      multipleMonths: 'MMM D',
      multipleYears: 'MMM D, yyyy'
    },
    toDate: {
      multipleDays: 'D, yyyy',
      multipleMonths: 'MMM D, yyyy',
      multipleYears: 'MMM D, yyyy'
    }
  }
};
